import { render, staticRenderFns } from "./checkDetail.vue?vue&type=template&id=01673bcb&scoped=true"
import script from "./checkDetail.vue?vue&type=script&lang=js"
export * from "./checkDetail.vue?vue&type=script&lang=js"
import style0 from "./checkDetail.vue?vue&type=style&index=0&id=01673bcb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01673bcb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01673bcb')) {
      api.createRecord('01673bcb', component.options)
    } else {
      api.reload('01673bcb', component.options)
    }
    module.hot.accept("./checkDetail.vue?vue&type=template&id=01673bcb&scoped=true", function () {
      api.rerender('01673bcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/feeType/cmp/checkDetail.vue"
export default component.exports